import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const historyInvoiceApi = createAsyncThunk(
  "historyInvoice",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/customTrade/getOrderDetails",
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

const historyInvoiceSlice = createSlice({
  name: "historyInvoice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(historyInvoiceApi.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(historyInvoiceApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(historyInvoiceApi.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to fetch invoice history";
      });
  },
});

export default historyInvoiceSlice.reducer;
